const { populate } = require('@/functions/objects');

class CustomerScreenQRCodeData {
    constructor(data = {}) {
        /**
         * Content for the QR code. Usually a URL, but not necessarily.
         *
         * @type {string}
         */
        this.content = '';

        /**
         * Optional text to display above the code to the customer.
         * This should be actual text, not a lang string key and can contain HTML.
         * Do not send unescaped used-supplied data here because it will be displayed as HTML!
         *
         * @type {string}
         */
        this.title = '';

        populate(this, data);
    }
}

module.exports = CustomerScreenQRCodeData;
